import { buildLogoBars, LOGO_VIEWBOX } from '@/assets/logo';

/** React rendition of the PulseAI pulse-bar mark; see src/assets/logo.ts for the shared geometry. */
export default function Logo({ size = 28, color = 'currentColor' }: { size?: number; color?: string }) {
  const bars = buildLogoBars();
  const viewBoxParts = LOGO_VIEWBOX.split(' ').map(Number);
  const viewBoxWidth = viewBoxParts[2];
  const viewBoxHeight = viewBoxParts[3];
  const height = Math.round(size * (viewBoxHeight / viewBoxWidth));

  return (
    <svg width={size} height={height} viewBox={LOGO_VIEWBOX} fill="none" xmlns="http://www.w3.org/2000/svg">
      {bars.map((bar, index) => (
        <rect key={index} x={bar.x} y={bar.y} width={bar.width} height={bar.height} rx={bar.width / 2} fill={color} />
      ))}
    </svg>
  );
}
